//contract Address :  0xc1Ee96Dc9065A3ca4299E0476Da5e59a7A398d93
import ABI from './SSI.json'
export const SSIAddress = "0xc1Ee96Dc9065A3ca4299E0476Da5e59a7A398d93";
export const SSIABI = ABI.abi;
